import { CSSObject, Theme } from '@emotion/react';

export const SIDE_NAV_DRAWER_WIDTH_EXPANDED = '256px';

export const SIDE_NAV_DRAWER_WIDTH_COLLAPSED = '72px';

export const drawerWidth = SIDE_NAV_DRAWER_WIDTH_EXPANDED;

export const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  borderRight: 'none',
  zIndex: theme.zIndex.drawer,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

export const closedMixin = (theme: Theme): CSSObject => ({
  zIndex: theme.zIndex.drawer,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  borderRight: 'none',
  overflowX: 'hidden',
  width: SIDE_NAV_DRAWER_WIDTH_COLLAPSED,
  [theme.breakpoints.up('sm')]: {
    width: SIDE_NAV_DRAWER_WIDTH_COLLAPSED,
  },
});
